/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */
/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';

import { DrawerProvider } from '../../contexts/drawer-context';
import { ScreenResizerProvider } from '../../contexts/screen-resize-context';
import { MarketoProvider } from '../../contexts/marketo-context';

import { MasterLayout } from '../master';
import { Logo } from '../../components/atoms/logo';

const NotFoundLayout = ({ children, className, locale = 'en' }) => (
	<ScreenResizerProvider>
		<DrawerProvider>
			<MarketoProvider>
				<MasterLayout>
					<section className="relative flex items-center justify-between w-full glu2xl:gap-10 mx-auto max-w-m-screen">
						<div className="flex items-center p-4 lg:py-6 header-left">
							<Logo width={126} height={36} locale={locale} />
						</div>
					</section>

					<main id="main" className={className}>
						{children}
					</main>
				</MasterLayout>
			</MarketoProvider>
		</DrawerProvider>
	</ScreenResizerProvider>
);

NotFoundLayout.defaultProps = {
	className: '',
};

NotFoundLayout.propTypes = {
	children: PropTypes.node.isRequired,
	className: PropTypes.string,
};

export { NotFoundLayout };
